import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import themeTable from '../../../themes/theme';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import exportIcon from '../../../assets/export';
import saveFileIcon from '../../../assets/saveFileIcon';
import InvoiceDownloadfiles from '../../../assets/InvoiceDownloadfiles';
import downloadReceipt from '../../../assets/images/payment-download.png';
import paymentHistoryDownload from '../../../assets/images/payment-history-download.svg';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import downarrowIcon from '../../../assets/downArrow';
import './PaymentTable.scss';
import invoiceServiceInstance from 'src/services/invoice/InvoiceService';
import MUIDataTable, { Responsive } from 'mui-datatables';
import CustomPaginator from 'src/components/common/CustomPaginator';
import Button from '@material-ui/core/Button';
import { Fade, Menu, MenuItem } from '@material-ui/core';
import InvoiceService from 'src/services/invoice';
import LocaleFormating from 'src/translation/localeFormating';
import { downloadFile } from 'src/utils/downloadHelper';
import theme from '../../../themes/theme';
import { removeColumnOrganiser } from 'src/utils/commonUtils';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import Checkbox from 'src/components/common/Checkbox';
import * as _ from 'lodash';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { indexOf, mapValues } from 'lodash';
import { PhotoSizeSelectLargeTwoTone } from '@material-ui/icons';
export default function PaymentTable(props: any) {
  const [rowscount, setRowscount] = React.useState([]);
  const [paymentHistoryData, setPaymentHistoryData] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [apiLoader, handleApiLoader] = React.useState(false);
  const [showLoaderOnAction, setShowLoaderOnAction] = React.useState(false);
  const [allSelectedData, setAllSelectedData] = React.useState([]);
  const [rowsExpandedList, setRowsExpandedList] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [showInvoiceError, setShowInvoiceError] = React.useState(false);
  const [numberOfRowsPerPage, setNumberOfRowsPerPage] = React.useState(20);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [hideBtnShowError, setHideBtnShowError] = React.useState(false);
  const [showPaymentError, setShowPaymentError] = React.useState(false);
  const [displayState, setDisplayState] = React.useState([]);
  const [childcheckState, setchildcheckState] = React.useState([false]);
  const [sortOrderState, setSortOrderState] = React.useState({
    name: 'paymentDate',
    direction: 'desc'
  });
  const [checked, setChecked]: any = React.useState([]);
  const [parentchecked, setparentChecked]: any = React.useState([false]);
  const all = [...checked];
  const [count, setCount] = React.useState(false);

  // const [filtervalues, setfiltervalues] = React.useState();

  React.useEffect(() => {
    // const { filtervalues, pagination } = props;

    handleApiLoader(true);
    const activeAccount = localStorage.getItem('activeAccount');
    if (props.filtervalues) {
      invoiceServiceInstance
        .getPaymentHistory(activeAccount, props.filtervalues)
        .then((response: any) => {
          const resData = response.data;
          // setPaymentHistoryData(resData);
          setPaymentHistoryData(paymentHistoryDataMapping(resData));
          handleApiLoader(false);
        })
        .catch(error => {
          console.log(error);
          handleApiLoader(false);
          // removeColumnOrganiser();
          setPaymentHistoryData([]);
        });
    }
  }, [props.filtervalues]);

  React.useEffect(() => {
    // removeColumnOrganiser();
  }, [paymentHistoryData]);
  React.useEffect(() => {
    // if ((!_.isEqual(columns, columns1))) {
    setColumns(columns1);
    // }
  }, []);
  function getAmountFixedValue(amount: any) {
    const amountVal = Number(amount);
    if (amountVal) {
      return `$${amountVal.toFixed(2)}`;
    }
    return 0;
  }

  function checkValue(value: any) {
    if (value) {
      return value;
    }
    return '-';
  }

  function getDateFormat(date: any) {
    if (date) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return month + '/' + day + '/' + year;
    }
    return '-';
  }
  function getdownLoadDateFormat(date: any) {
    if (date) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return year + '-' + month + '-' + day;
    }
    return '-';
  }
  function handleOriginalinvoice(
    e: any,
    invoiceNo: string,
    invoiceDate: string,
    paymentReference: string,
    checkindex: any,
    parentindex: any
  ) {
    const clickedCategory = checked.indexOf(invoiceNo);

    let obj: any = [];
    const newArr = [...paymentHistoryData];

    if (clickedCategory === -1 && e.target.checked) {
      obj = {
        invoiceNo,
        invoiceDate
      };
      setCount(true);
      newArr[parentindex].isSelected = true;
      newArr[parentindex].mappedPayment[checkindex].checkedstatus = true;
      newArr[parentindex].mappedPayment[checkindex].Ischeckedind = '';
      all.push(obj);
    } else {
      all.splice(obj.invoiceNo, 1);
      setCount(false);
      newArr[parentindex].isSelected = false;
      newArr[parentindex].mappedPayment[checkindex].checkedstatus = false;
      newArr[parentindex].mappedPayment[checkindex].Ischeckedind = 'unchecked';
    }
    setChecked(all);
    setPaymentHistoryData(newArr);
  }

  function handleOriginalinvoicebulk(
    invoiceNo: string,
    invoiceDate: string,

    allrowselection: any
  ) {
    let bulkobj: any = [];
    const checkarr: any = [];
    const filteredarr: any = [];
    const newArr = [...paymentHistoryData];
    newArr.map(newarrval =>
      newarrval.mappedPayment.forEach(
        (mapvalue: any) => ((mapvalue.checkedstatus = false), newArr),
        ((newarrval.isSelected = false), (newarrval.indvalchecked = ''))
      )
    );

    allrowselection.map((indexvalue: any) => {
      newArr[indexvalue.dataIndex].mappedPayment.forEach((mapval: any) => {
        if (mapval.Ischeckedind === '') {
          mapval.checkedstatus = true;
        }

        newArr[indexvalue.dataIndex].isSelected = true;
        newArr[indexvalue.dataIndex].indvalchecked = 'checked';
        bulkobj = {
          invoiceNo,
          invoiceDate
        };

        all.push(bulkobj);
      });
    });
    newArr.forEach((val: any, index: any) => {
      val.mappedPayment.forEach((valmap: any) => {
        if (valmap.Ischeckedind === 'unchecked' && val.indvalchecked === '') {
          valmap.Ischeckedind = '';
        }
      });
    });

    all.map((invno: any) => {
      const checklist = checkarr.filter(
        (invfil: any) => invfil.invoiceNo === invno.invoiceNo
      );
      if (checklist.length === 0) {
        checkarr.push({
          invoiceNo: invno.invoiceNo,
          invoiceDate: invno.invoiceDate
        });
      }
    });

    setChecked(checkarr);

    setPaymentHistoryData(newArr);
  }

  function resetSubtable() {
    const resetarr = [...paymentHistoryData];
    resetarr.map(resetvalue => {
      (resetvalue.isSelected = false),
        resetvalue.mappedPayment.forEach(
          (checkreset: any) => (checkreset.checkedstatus = false)
        );
    });
  }

  const CustomToolbar = () => {
    return (
      <div className="select-credits margintb10px">
        <div className="d-flex selected-items">
          <div className="d-flex number-of-items">
            <span className="items">
              {allSelectedData.length} payment(s) selected{' '}
            </span>
            <span className="mobile-view">
              {allSelectedData.length} payment(s) selected{' '}
            </span>
            <span className="clear-mg " onClick={clearClick}>
              clear
            </span>
          </div>
        </div>
      </div>
    );
  };

  const CustomToolbar1 = () => {
    return (
      <div className="select-credits margintb10px">
        <div className="d-flex selected-items">
          <div className="d-flex number-of-items">
            <span className="items">{checked.length} invoice(s) selected </span>
            <span className="mobile-view">
              {checked.length} invoice(s) selected{' '}
            </span>
            <span className="clear-mg " onClick={clearClickInvoice}>
              clear
            </span>
          </div>
        </div>
      </div>
    );
  };

  const clearClick = () => {
    setRowscount([]);
    setAllSelectedData([]);
  };
  function clearClickInvoice() {
    setCount(false);
    setChecked([]);
    resetSubtable();
  }
  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    // setRowscount(rowsSelectedpath);
    const allSelections: any[] = [];
    if (currentRowsSelected.length === 0) {
      setRowscount([]);
      setAllSelectedData([]);
      setCount(false);
      setChecked([]);
      resetSubtable();
    } else {
      setRowscount(rowsSelectedpath);
      rowsSelectedpath.map((index: any) => {
        // const index=currentRowsSelected[0].index
        if (paymentHistoryData.length > 0) {
          const obj = {
            amountPaid: paymentHistoryData[index].amountPaid,
            invoiceDate: paymentHistoryData[index].invoiceDate,
            invoiceDescription: paymentHistoryData[index].invoiceDescription,
            invoiceNumber: paymentHistoryData[index].invoiceNumber,
            number: paymentHistoryData[index].number,
            orderNumber: paymentHistoryData[index].orderNumber,
            paymentDate: paymentHistoryData[index].paymentDate,
            // paymentDescription: paymentHistoryData[index].paymentDescription,
            paymentReference: paymentHistoryData[index].paymentReference,
            paymentType: paymentHistoryData[index].paymentType,
            purchaseOrder: paymentHistoryData[index].purchaseOrder,
            remainingAmount: paymentHistoryData[index].remainingAmount,
            totalAmount: paymentHistoryData[index].totalAmount,
            transactionId: paymentHistoryData[index].transactionId,
            mappedPayment: paymentHistoryData[index].mappedPayment
          };
          allSelections.push(obj);
          obj.mappedPayment.forEach((datainfo: any, indexvalue: any) => {
            handleOriginalinvoicebulk(
              datainfo.invoiceNumber,
              datainfo.invoiceDate,
              allRowsSelected
            );
          });
        }
      });
      setAllSelectedData(allSelections);

      resetindividual(allSelections, allRowsSelected);
    }
  };
  function resetindividual(allSelections: any, allRowsSelected: any) {
    const filteredarr: any = [];
    const newArr = [...paymentHistoryData];
    if (allSelections.length !== 0) {
      allSelections.forEach((selecteditem: any) =>
        selecteditem.mappedPayment.forEach((mappeditem: any) => {
          if (mappeditem.Ischeckedind === '') {
            filteredarr.push({
              invoiceNo: mappeditem.invoiceNumber,
              invoiceDate: mappeditem.invoiceDate
            });
          }
        })
      );
    } else {
      setCount(false);
      setChecked([]);
      resetSubtable();

      newArr.forEach((val: any, index: any) => {
        val.mappedPayment.forEach((valmap: any) => {
          if (
            valmap.Ischeckedind === 'unchecked' &&
            val.indvalchecked === 'checked'
          ) {
            valmap.Ischeckedind = '';
            val.indvalchecked = '';
          }
        });
      });
    }

    setChecked(filteredarr);
    setPaymentHistoryData(newArr);
  }
  const checkDisplayState = (
    fileldName: string,
    state: boolean,
    isUpdate: boolean
  ) => {
    const stateList = displayState;
    let stateVal = state;
    if (isUpdate) {
      stateList[fileldName] = state ? 'add' : 'remove';
      if(stateList[fileldName]==="add"){
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        localStorage.setItem(fileldName, "pcol-checked");
        }else{
          localStorage.setItem(fileldName, "ca-pcol-checked");  
        } 
      }else{
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        localStorage.setItem(fileldName, "pcol-unchecked"); 
        }else{
          localStorage.setItem(fileldName, "ca-pcol-unchecked"); 
        }
      }
    } else {
      const colsStatus = localStorage.getItem(fileldName);
      if (stateList[fileldName]) {
       
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
          if(colsStatus==="pcol-unchecked"){
            stateVal = stateList[fileldName] === 'add' ? false : true;
          }else{
          stateVal = stateList[fileldName] === 'add' ? true : false;
          }
        }else{
  
          if(colsStatus==="ca-pcol-unchecked"){
            stateVal = stateList[fileldName] === 'add' ? false : true;
          }else{
          stateVal = stateList[fileldName] === 'add' ? true : false;
          }
        }
      } else {
        stateList[fileldName] = state ? 'add' : 'remove';
      }
    }
    if (fileldName === 'paymentReference') {
      stateList[fileldName] = 'add';
    }
    if (!_.isEqual(displayState, stateList)) {
      setDisplayState(stateList);
    }
    const abc = fileldName === 'paymentReference' ? true : stateVal;

    return abc;
  };

  const columns1 = [
    {
      label: `${i18n.t('invoices.paymentRefer')}`,
      name: 'paymentReference',
      options: {
        display: true,
        viewColumns: false,
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              <span
                className="invoice-under-line"
                onClick={() => onClickPaymentReference(tablemeta)}
              >
                {value}
              </span>
            </label>
          );
        }
      }
    },
    {
      label: `${i18n.t('invoices.paymentDate')}`,
      name: 'paymentDate',
      options: {
        display: checkDisplayState('paymentDate', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return <label>{getDateFormat(value)}</label>;
        }
      }
    },
    {
      label: `${i18n.t('invoices.paymentType')}`,
      name: 'paymentType',
      options: {
         display: checkDisplayState('paymentType', true, false)
      }
    },
    {
      label: `${i18n.t('invoices.accNoCardNo')}`,
      name: 'number',
      options: {
         display: checkDisplayState('number', true, false)
      }
    },
    // {
    //   label: 'Description',
    //   name: 'paymentDescription',
    //   options: { display: checkDisplayState('paymentDescription', true, false) }
    // },
    {
      label: `${i18n.t('invoices.amountPaid')}`,
      name: 'amountPaid',
      options: {
        display: checkDisplayState('amountPaid', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    {
      label: 'Invoice Number',
      name: 'invoiceNumber',
      options: { display: 'excluded' }
    },
    {
      label: 'Invoice Date',
      name: 'invoiceDate',
      options: { display: 'excluded' }
    },
    {
      label: 'orderNumber',
      name: 'orderNumber',
      options: { display: 'excluded' }
    },
    {
      label: 'purchaseOrder',
      name: 'purchaseOrder',
      options: { display: 'excluded' }
    },
    {
      label: 'invoiceDescription',
      name: 'invoiceDescription',
      options: { display: 'excluded' }
    },
    {
      label: 'totalAmount',
      name: 'totalAmount',
      options: { display: 'excluded' }
    },
    {
      label: 'remainingAmount',
      name: 'remainingAmount',
      options: { display: 'excluded' }
    },
    {
      label: 'transactionId',
      name: 'transactionId',
      options: { display: 'excluded' }
    }
  ];
  const invoiceHandleChange = (
    invoiceNo: string,
    invoiceDate: string
  ) => () => {
    const clickedCategory = checked.indexOf(invoiceNo);

    if (clickedCategory === -1) {
      const obj = {
        invoiceNo,
        invoiceDate
      };
      all.push(obj);
    } else {
      console.log('Elseblock');
    }

    setChecked(all);
  };

  const handleMenuItemClick = (event: any, index: number) => {
    const { filtervalues, pagination } = props;
    setSelectedIndex(index);
    setAnchorEl(null);
    if (allSelectedData && allSelectedData.length > 0) {
      // const selectedInvoices: any = [];
      // rowscount.forEach(ele => {
      //   const newObj = {
      //     amountPaid: '',
      //     invoiceDate: '',
      //     invoiceDescription: '',
      //     invoiceNumber: '',
      //     number: '',
      //     orderNumber: '',
      //     paymentDate: '',
      //     paymentDescription: '',
      //     paymentReference: '',
      //     paymentType: '',
      //     purchaseOrder: '',
      //     remainingAmount: '',
      //     totalAmount: ''
      //   };
      //   const indexVal = paymentHistoryData.findIndex(
      //     (val: any, i: any) => i === ele
      //   );
      //   newObj.amountPaid = paymentHistoryData[indexVal].amountPaid;
      //   newObj.invoiceDate = paymentHistoryData[indexVal].invoiceDate;
      //   newObj.invoiceDescription =
      //     paymentHistoryData[indexVal].invoiceDescription;
      //   newObj.invoiceNumber = paymentHistoryData[indexVal].invoiceNumber;
      //   newObj.number = paymentHistoryData[indexVal].number;
      //   newObj.orderNumber = paymentHistoryData[indexVal].orderNumber;
      //   newObj.paymentDate = paymentHistoryData[indexVal].paymentDate;
      //   newObj.paymentDescription =
      //     paymentHistoryData[indexVal].paymentDescription;
      //   newObj.paymentReference = paymentHistoryData[indexVal].paymentReference;
      //   newObj.paymentType = paymentHistoryData[indexVal].paymentType;
      //   newObj.purchaseOrder = paymentHistoryData[indexVal].purchaseOrder;
      //   newObj.remainingAmount = paymentHistoryData[indexVal].remainingAmount;
      //   newObj.totalAmount = paymentHistoryData[indexVal].totalAmount;
      //   selectedInvoices.push(newObj);
      // });
      if (allSelectedData && allSelectedData.length > 0) {
        setShowLoaderOnAction(true);
        // const selectedData = constructionSelectedData(allSelectedData)
        const selectedData: any[] = [];
        allSelectedData.forEach(element => {
          const selectedEData: any[] = element.mappedPayment;
          selectedEData.forEach(elmt => {
            selectedData.push(elmt);
          });
        });
        InvoiceService.exportSelectedPaidInvoices(
          exportOptions[index].value,
          selectedData
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            downloadFile(
              response.data,
              `SelectedInvoices_${LocaleFormating.getNowDate('short')}.${
                exportOptions[index].value
              }`
            );
          })
          .catch(error => {
            console.log(error);
            setShowLoaderOnAction(false);
          });
      }
    } else {
      if (exportOptions[index].value === 'pdf') {
        setShowLoaderOnAction(true);
        InvoiceService.exportPaymentHistoryInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.pdf`
            );
          })
          .catch(error => {
            console.log(error);
            setShowLoaderOnAction(false);
          });
      } else if (exportOptions[index].value === 'xlsx') {
        setShowLoaderOnAction(true);
        InvoiceService.exportPaymentHistoryInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.xlsx`
            );
          })
          .catch(error => {
            console.log(error);
            setShowLoaderOnAction(false);
          });
      } else if (exportOptions[index].value === 'csv') {
        setShowLoaderOnAction(true);
        InvoiceService.exportPaymentHistoryInvoices(
          exportOptions[index].value,
          filtervalues,
          pagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.csv`
            );
          })
          .catch(error => {
            console.log(error);
            setShowLoaderOnAction(false);
          });
      }
    }
  };

  const onClickInvoiceNo = (invoiceNo: string, invoiceDate: string) => {
    setShowLoaderOnAction(true);
    InvoiceService.downloadInvoice(invoiceNo, invoiceDate)
      .then((response: any) => {
        setHideBtnShowError(false);
        setShowLoaderOnAction(false);
        downloadFile(
          response.data,
          `invoice-${invoiceNo}-${LocaleFormating.getNowDate('short')}.pdf`
        );
      })
      .catch(error => {
        console.log(error);
        setHideBtnShowError(true);
        setShowLoaderOnAction(false);
      });
  };
  const onClickPaymentReference = (tablemeta: any) => {
    setShowLoaderOnAction(true);
    InvoiceService.downloadPaymentReference([
      {
        transactionId: tablemeta.rowData[12].toString(),
        paymentReference: tablemeta.rowData[0].toString()
      }
    ])
      .then((response: any) => {
        setShowPaymentError(false);
        setShowLoaderOnAction(false);
        downloadFile(
          response.data,
          `payment-${tablemeta.rowData[0]}-${tablemeta.rowData[12]}.pdf`
        );
      })
      .catch(error => {
        console.log(error);
        setShowPaymentError(true);
        setShowLoaderOnAction(false);
      });
  };

  const paymentHistoryDataMapping = (data: any[]) => {
    const paymentHistoryDataMap: any[] = [];
    data.forEach(sel => {
      let creditMapped = {};
      // let exestingCreditMapped: any[] = [];
      const key = 'checkedstatus';
      const value = false;
      const jSel = JSON.parse(JSON.stringify(sel));
      Object.assign(jSel, { checkedstatus: false, Ischeckedind: '' });

      // console.log(jSel,'jsel');
      const isExist = paymentHistoryDataMap.filter(
        a => a.transactionId === sel.transactionId.toString()
      );
      if (isExist.length > 0) {
        // exestingCreditMapped = isExist[0]['mappedPayment'];
        // exestingCreditMapped.push(jSel);
        isExist[0]['mappedPayment'].push(jSel);
        // isExist[0]['amountPaid'] = (
        //   isExist[0]['amountPaid'] / 1 +
        //   jSel.amountPaid / 1
        // ).toString();
        isExist[0]['number'] = jSel.number
          ? jSel.number.substring(jSel.number.length - 4, jSel.number.length)
          : isExist[0]['number']
          ? isExist[0]['number'].substring(
              isExist[0]['number'].length - 4,
              isExist[0]['number'].length
            )
          : '';
        creditMapped['isSelected'] = false;
        creditMapped['indvalchecked'] = '';
        // creditMapped['checkedstatus'] = false;
      } else {
        creditMapped = JSON.parse(JSON.stringify(sel));
        creditMapped['mappedPayment'] = [jSel];
        creditMapped['number'] = jSel.number
          ? jSel.number.substring(jSel.number.length - 4, jSel.number.length)
          : '';
        creditMapped['isSelected'] = false;
        creditMapped['indvalchecked'] = '';
        // creditMapped['checkedstatus'] = false;
        paymentHistoryDataMap.push(creditMapped);
      }
    });

    return paymentHistoryDataMap;
  };

  const handleDownloadListItemInvoice = () => {
    if (checked && checked.length > 0) {
      const selectedInvoices: any[] = [];
      // const selectedInvoiceList: string[] = [];
      checked.map((sel: any) => {
        const isExist = selectedInvoices.filter(
          a => a.invoiceNo === sel.invoiceNo.toString()
        );
        if (isExist.length === 0) {
          selectedInvoices.push({
            invoiceNo: sel.invoiceNo.toString(),
            invoiceDate: sel.invoiceDate.toString()
          });
          // selectedInvoiceList.push(sel.invoiceNumber.toString());
        }
      });

      if (selectedInvoices && selectedInvoices.length > 0) {
        setShowLoaderOnAction(true);
        InvoiceService.downloadInvoices(selectedInvoices)
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setShowInvoiceError(false);
            if (response.status === 206) {
              setShowInvoiceError(true);
            }
            if (selectedInvoices.length === 1) {
              downloadFile(
                response.data,
                `invoice-${checked[0].invoiceNo}-${LocaleFormating.getNowDate(
                  'short'
                )}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `invoices${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          })
          .catch(error => {
            console.log(error);
            setShowInvoiceError(true);
            setShowLoaderOnAction(false);
          });
      }
    }
  };

  const handleDownloadListItem = () => {
    if (allSelectedData && allSelectedData.length > 0) {
      const selectedTransactions: any[] = [];
      allSelectedData.map(sel => {
        const isExist = selectedTransactions.filter(
          a => a.transactionId === sel.transactionId.toString()
        );
        if (isExist.length === 0) {
          selectedTransactions.push({
            transactionId: sel.transactionId.toString(),
            paymentReference: sel.paymentReference.toString()
          });
        }
      });
      if (selectedTransactions && selectedTransactions.length > 0) {
        setShowLoaderOnAction(true);
        InvoiceService.downloadPaymentReference(selectedTransactions)
          .then((response: any) => {
            setShowPaymentError(false);
            setShowLoaderOnAction(false);
            if (response.status === 206) {
              setShowPaymentError(true);
            }
            // console.log(
            //   'response.headers',
            //   response.headers,
            //   selectedTransactions.length
            // );
            // if (
            //   response.headers &&
            //   response.headers.paymentreceiptsfilesstatus
            // ) {
            //   const headerJson = JSON.parse(
            //     response.headers.paymentreceiptsfilesstatus
            //   );
            //   console.log(
            //     'headerJson',
            //     headerJson.paymentReceiptsFilesStatus.found.length,
            //     selectedTransactions.length,
            //     headerJson
            //   );
            //   if (
            //     headerJson.paymentReceiptsFilesStatus.found.length <
            //     selectedTransactions.length
            //   ) {
            //     console.log(
            //       'found',
            //       headerJson.paymentReceiptsFilesStatus.found.length,
            //       selectedTransactions.length
            //     );
            //     setShowPaymentError(true);
            //     console.log(
            //       'found error',
            //       headerJson.paymentReceiptsFilesStatus.found.length,
            //       selectedTransactions.length
            //     );
            //     // const found = headerJson.paymentReceiptsFilesStatus.found;
            //     // const notFound = selectedPaymentList.filter(
            //     //   el => !found.includes(el)
            //     // );
            //   }
            // }
            if (selectedTransactions.length === 1) {
              downloadFile(
                response.data,
                `payment-${allSelectedData[0].paymentReference}-${allSelectedData[0].transactionId}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `payments${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          })
          .catch(error => {
            console.log(error);
            setShowPaymentError(true);
            setShowLoaderOnAction(false);
          });
      }
    }
  };
  const handleClickListItem = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const printReceipt = () => {
    if (
      rowscount &&
      rowscount.length > 0 &&
      paymentHistoryData &&
      paymentHistoryData.length > 0
    ) {
      const invoicesNumber: string[] = [];
      rowscount.forEach(ele => {
        const indexVal = paymentHistoryData.findIndex(
          (val: any, i: any) => i === ele
        );
        invoicesNumber.push(
          paymentHistoryData[indexVal].invoiceNumber.toString()
        );
      });
      if (invoicesNumber.length !== 0) {
        InvoiceService.downloadInvoices(invoicesNumber).then(
          (response: any) => {
            if (invoicesNumber.length === 1) {
              downloadFile(
                response.data,
                `invoice-${LocaleFormating.getNowDate('short')}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `invoices${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          }
        );
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
  ];

  const options = {
    filter: false,
    // filterType: 'checkbox',
    search: false,
    download: false,
    disableToolbarSelect: true,
    rowsSelected: rowscount,
    pagination: true,
    rowsPerPageOptions: [10, 20, 30, 40, 50, 100],
    rowsPerPage: numberOfRowsPerPage,
    print: false,
    sort: true,
    expandableRows: true,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    rowsExpanded: rowsExpandedList,
    onRowClick: (rowData: any, rowState: any) => {
      console.log(rowData, rowState, 'rowinfo');
    },
    onRowsSelect: (rowData: any, rowState: any) => {
      console.log(rowData, rowState, 'rowinfo');
    },

    renderExpandableRow: (rowData: any, rowMeta: any) => {
      // console.log(rowData, rowMeta);
      const selectedCreditDataIndex = paymentHistoryData.findIndex(
        (el: any) => el.transactionId === rowData[12]
      );
      const selectedCreditData =
        paymentHistoryData[selectedCreditDataIndex].mappedPayment;

      if (selectedCreditData && selectedCreditData.length > 0) {
        return selectedCreditData.map((val: any, index: any) => (
          <TableRow className="paymentTable-subtable">
            <TableCell colSpan={14}>
              <div className="paymentTable-subtable-div">
                <label className="d-flex">
                  <span>
                    {/* <input type="checkbox" className="rp-checkbox--input custom-checkbox" onChange={invoiceHandleChange(checkValue(val.invoiceNumber), getdownLoadDateFormat(val.invoiceDate))} /> */}

                    <input
                      type="checkbox"
                      className="rp-checkbox--input custom-checkbox"
                      onChange={e =>
                        handleOriginalinvoice(
                          e,
                          checkValue(val.invoiceNumber),
                          getdownLoadDateFormat(val.invoiceDate),
                          val.paymentReference,
                          index,
                          selectedCreditDataIndex
                        )
                      }
                      checked={val.checkedstatus}
                    />
                  </span>
                  <span>
                    <b>{i18n.t('accountMonthlyStatements.invoiceTag')}</b>{' '}
                    <br />
                    <span
                      className="invoice-under-line"
                      onClick={() =>
                        onClickInvoiceNo(
                          checkValue(val.invoiceNumber),
                          getdownLoadDateFormat(val.invoiceDate)
                        )
                      }
                    >
                      {checkValue(val.invoiceNumber)}
                    </span>
                  </span>
                  {/* <span>{checkValue(val.invoiceNumber)}</span> */}
                </label>
                {/* <label>
                  <b>{i18n.t('accountMonthlyStatements.invoiceTag')}</b> <br />
                  <span
                    className="invoice-under-line"
                    onClick={() =>
                      onClickInvoiceNo(
                        checkValue(val.invoiceNumber),
                        getdownLoadDateFormat(val.invoiceDate)
                      )
                    }
                  >
                    {checkValue(val.invoiceNumber)}
                  </span>
                </label> */}
                <label>
                  <b>{i18n.t('accountMonthlyStatements.invoiceDate')} </b>{' '}
                  <br />
                  {getDateFormat(val.invoiceDate)}
                </label>
                <label>
                  <b>{i18n.t('invoices.orderNo')} </b> <br />
                  {checkValue(val.orderNumber)}
                </label>
                <label>
                  <b>{i18n.t('invoices.purchaseOrderNo')} # </b> <br />
                  {checkValue(val.purchaseOrder)}
                </label>
                <label>
                  <b>{i18n.t('invoices.description')}</b> <br />
                  {checkValue(val.invoiceDescription)}
                </label>
                <label>
                  <b>{i18n.t('invoices.TotalAmount')}</b> <br />
                  {currencyFormatter(val.totalAmount)}
                </label>
                <label>
                  <b>{i18n.t('invoices.RemainingAmount')} </b> <br />
                  {currencyFormatter(val.remainingAmount)}
                </label>
              </div>
            </TableCell>
          </TableRow>
        ));
      }
      return null;
    },
    onRowExpansionChange: (
      curExpanded: any,
      allExpanded: any[],
      rowsExpanded: any
    ) => {
      setRowsExpandedList(allExpanded.map(a => a.dataIndex));
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      setNumberOfRowsPerPage(numberOfRows);
    },
    draggableColumns: {
      enabled: true,
      transitionTime: 300
    },
    sortOrder: sortOrderState as any,
    onRowSelectionChange,
    customToolbarSelect: () => <CustomToolbar />,
    customToolbar: () => (
      <MuiThemeProvider theme={theme}>
        <span className="export-icon">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClickListItem}
            disabled={!allSelectedData.length && !paymentHistoryData.length}
          >
            <img className="image-icon" src={exportIcon} />
            <img className="down-arrow" src={downarrowIcon} />
          </Button>
        </span>
        <span className="export-icon save-icon">
          <Button
            onClick={handleDownloadListItem}
            disabled={!allSelectedData.length}
          >
            <Tooltip title="Payment Receipt Download" placement="bottom">
              <img className="image-icon" src={saveFileIcon} />
            </Tooltip>
          </Button>
        </span>
        <span className="export-icon save-icon">
          <Button
            onClick={handleDownloadListItemInvoice}
            disabled={!checked.length}
          >
            <Tooltip title="Invoice Download" placement="bottom">
              <img className="image-icon" src={InvoiceDownloadfiles} />
            </Tooltip>
          </Button>
        </span>
        {/* <span className="download-wrapper">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={printReceipt}
            disabled={!rowscount.length}
          >
            <img className="download-icon" src={paymentHistoryDownload} />
          </Button>
        </span> */}
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted={true}
          open={Boolean(anchorEl)}
          TransitionComponent={Fade}
          onClose={handleClose}
        >
          {exportOptions.map((exportoptions, index) => (
            <MenuItem
              key={exportoptions.value}
              // selected={index === index}
              onClick={event => handleMenuItemClick(event, index)}
            >
              {exportoptions.label}
            </MenuItem>
          ))}
        </Menu>

        {/* <div className="rp-product-status--paginator">
          <CustomPaginator
            activePage={
              props.pagination.pageNumber ? props.pagination.pageNumber + 1 : 1
            }
            totalPages={props.pagination.totalPages}
            itemsPerPage={props.pagination.pageSize}
            onPageChanged={handlePagination}
            totalItems={props.pagination.totalPages * props.pagination.pageSize}
            showPageInfo={true}
            onPageSizeChange={handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={props.pagination.pageSize}
          />
        </div> */}
        <React.Fragment>
          {hideBtnShowError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setHideBtnShowError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {/* {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message8')}
                    <a href="mailto:reliablepartsar1@reliableparts.com">
                      reliablepartsar1@reliableparts.com
                    </a>{' '}
                    {i18n.t('invoices.message9')}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message8')}
                    <a href="mailto:accounts.receivable.us@reliableparts.com">
                      accounts.receivable.us@reliableparts.com
                    </a>{' '}
                    {i18n.t('invoices.message9')}
                  </div>
                )} */}
                <div className="error-message-to-show">
                  {i18n.t('invoices.downloaderror')}
                </div>
              </div>
            </Alert>
          ) : (
            ''
          )}
          {showPaymentError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setShowPaymentError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message13')}
                    <a href="mailto:reliablepartsar1@reliableparts.com">
                      reliablepartsar1@reliableparts.com
                    </a>{' '}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message13')}
                    <a href="mailto:accounts.receivable.us@reliableparts.com">
                      accounts.receivable.us@reliableparts.com
                    </a>{' '}
                  </div>
                )}
              </div>
            </Alert>
          ) : (
            ''
          )}
        </React.Fragment>
        {allSelectedData.length > 0 && <CustomToolbar />}
        {checked.length > 0 && <CustomToolbar1 />}
      </MuiThemeProvider>
    ),
    onViewColumnsChange: (changedColumn: any, action: any) => {
      if (changedColumn === 'paymentReference') {
        setColumns(columns1);
      } else {
        checkDisplayState(changedColumn, action === 'add' ? true : false, true);
        
      }
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      const dir = direction;
      setSortOrderState({ name: changedColumn, direction: dir });
    },
    onTableInit: (action: string, tableState: object) => {
      setColumns(columns1);
    },
    textLabels: {
      body: {
        noMatch: `${i18n.t('invoices.message14')}`,
        toolTip: `${i18n.t('invoices.sort')}`
      },
      pagination: {
        next: `${i18n.t('invoices.nextPage')}`,
        previous: `${i18n.t('invoices.previousPage')}`,
        rowsPerPage: `${i18n.t('invoices.rowsperpage')}`,
        displayRows: `${i18n.t('invoices.of')}`
      }
    }
  };

  return (
    <React.Fragment>
      <div className="section-loader">
        {showLoaderOnAction ? (
          <div className="loader-container">
            <div className="loader-content">
              {i18n.t('invoices.pleasewaitwhileweareprocessingyourrequest')}
            </div>
            <div className="loader" />
          </div>
        ) : (
          ''
        )}
        {apiLoader ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          <div className="payment-history">
            <MuiThemeProvider theme={theme}>
              <MUIDataTable
                title={''}
                data={paymentHistoryData.map((item: any) => {
                  return [
                    item.paymentReference / 1,
                    item.paymentDate,
                    // getDateFormat(item.paymentDate),
                    item.paymentType,
                    item.number,
                    // item.paymentDescription,
                    item.amountPaid / 1,
                    item.invoiceNumber,
                    item.invoiceDate,
                    item.orderNumber,
                    item.purchaseOrder,
                    item.invoiceDescription,
                    item.totalAmount,
                    item.remainingAmount,
                    item.transactionId
                  ];
                })}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
